$.lui("part",".part_item_faq",function (selector) {
    selector.on("click keydown","[data-click]",function (e) {
        if(e.type === 'keydown' && [' ','Enter'].indexOf(e.key) > -1){
            e.preventDefault();
            e.stopPropagation();
            toggle($(this).closest(selector))
        }

        if(e.type === 'click'){
            e.preventDefault();
            e.stopPropagation();
            toggle($(this).closest(selector))
        }
    })

    function toggle(el) {
        var head = el.find(".wrp_item_head");
        var body = el.find(".wrp_item_body");

        if(el.hasClass("state--active")) {
            body.stop().slideUp(function () {
                el.removeClass("state--active");
                head[0].ariaExpanded = false;
            })
        }
        else {
            el.addClass("state--expanding");
            body.stop().slideDown(function () {
                el.addClass("state--active").removeClass("state--expanding");
                head[0].ariaExpanded = true
            })
        }
    }
});
